export default {
      id: "color_bacteria_cloud_hello-usage",
      viewBox: "0 0 172 214",
      url: __webpack_public_path__ + "sprite.svg#color_bacteria_cloud_hello",
      toString: function () {
        return this.url;
      }
    }